import { addDays } from 'date-fns';

export const DEFAULT_TRIAL_DAYS = 14;

export const getTrialEndDate = (account) => account.billing?.trialEndsAt
  || addDays(new Date(account.billing.trialStartedAt), DEFAULT_TRIAL_DAYS);
